/**
 * Sentry 请求错误过滤工具：
 * - 统一提取 HTTP 状态码/业务错误码
 * - 识别可忽略的动态模块加载失败错误
 */
export function getRequestErrorStatus(error: any) {
  const status = error?.response?.status ?? error?.status

  return typeof status === 'number' ? status : undefined
}

/** 判断错误的 HTTP 状态码是否在过滤列表中。 */
export function isRequestErrorStatus(error: any, expectedStatuses: number[]) {
  const status = getRequestErrorStatus(error)

  return status !== undefined && expectedStatuses.includes(status)
}

/** 提取业务错误码（优先 error.code，其次响应体与 Sentry 序列化字段）。 */
export function getRequestErrorCode(event: any, error: any) {
  const code =
    error?.code ??
    error?.response?.data?.code ??
    event?.extra?.__serialized__?.code

  return typeof code === 'number' ? code : undefined
}

/** 判断业务错误码是否在过滤列表中。 */
export function isRequestErrorCode(
  event: any,
  error: any,
  expectedCodes: number[],
) {
  const code = getRequestErrorCode(event, error)

  return code !== undefined && expectedCodes.includes(code)
}

/**
 * 判断是否为动态导入模块加载失败：
 * TypeError: Failed to fetch dynamically imported module: <chunk-url>
 */
export function isDynamicImportFetchError(event: any, error: any) {
  const message =
    error?.message ??
    event?.exception?.values?.[0]?.value ??
    event?.logentry?.formatted ??
    ''

  return (
    typeof message === 'string' &&
    message.includes('Failed to fetch dynamically imported module')
  )
}
